import React from "react";
import InfoPage from "../components/InfoPage";

function Terms() {
  return (
    <InfoPage
      eyebrow="THE FINE PRINT"
      title="Terms & Conditions"
      subtitle="The terms for using our website and services."
      sections={[
        {
          title: "1. Website Use",
          content:
            "Placeholder: Explain the rules for accessing and using this website.",
        },
        {
          title: "2. Booking Requests",
          content:
            "Placeholder: Explain how appointment requests are submitted, reviewed, and confirmed.",
        },
        {
          title: "3. Services and Pricing",
          content:
            "Placeholder: Explain service descriptions, pricing, and possible price adjustments.",
        },
        {
          title: "4. Payments and Refunds",
          content:
            "Placeholder: Add your payment, deposit, refund, and dispute policies.",
        },
        {
          title: "5. Website Content",
          content:
            "Placeholder: Explain the permitted use of your website text, photos, and other content.",
        },
        {
          title: "6. Changes and Contact",
          content:
            "Placeholder: Explain how these terms may change and how visitors can contact you.",
        },
      ]}
    />
  );
}

export default Terms;